export const UNSAVED_VERSION = 1000;

export const PERCENT = [
  'apr',
  'onePayLeaseApr',
  'onePaymentRate',
  'ratePercentage',
  'residualPercentage',
  'tax',
];

export const CURRENCY = [
  'amount',
  'amountOverride',
  'amountOwed',
  'bookValue',
  'cost',
  'dealerCash',
  'appliedDealerCash',
  'dealerCost',
  'discount',
  'downPayment',
  'freight',
  'invoice',
  'maxAmount',
  'monthlyPayment',
  'monthlyPrice',
  'mrm',
  'msrp',
  'pack',
  'payOff',
  'price',
  'rebate',
  'residual',
  'retailPrice',
  'retailPriceWithoutBundleDiscountApplied',
  'tradeACV',
  'tradeInAllowance',
  'tradeValue',
  'value',
];

export const NUMBER = [
  'daysToFirstPayment',
  'mileage',
  'months',
  'rate',
  'residual',
  'termMiles',
  'termMonths',
];

export const BOOLEAN = ['tradeInTaxCredit', 'taxed', 'enabled', 'selected'];

export const GLOBAL_PROPERTIES = ['pencilTradeIns', 'selectedAccessories'];

export const FINANCE_TYPE_PROPERTIES = [
  'addOns',
  'fees',
  'protectionPlanProductPriceOverrides',
  'selectedProducts',
  'tax',
  'taxBreakdown',
];

export const PRECISION_MAP = new Map<string, number>([['rate', 8]]);
